import {FC, PropsWithChildren} from "react";
import { useDropdownContext } from "./context";

interface DropdownValueProps {
    value: string | number;
}

const DropdownValue: FC<PropsWithChildren<DropdownValueProps>> = ({ value, children }) => {

    const context = useDropdownContext();

    if (context?.value !== value) {
        return null;
    }

    return (
        <>{children}</>
    )
}

export default DropdownValue;